import { render, staticRenderFns } from "./family-modal.vue?vue&type=template&id=20471d64"
import script from "./family-modal.vue?vue&type=script&lang=js"
export * from "./family-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports